module.exports = __webpack_public_path__ + "img/mt.6aefa614.png";